import React from "react";
import { motion } from "framer-motion";
import Hero from "./Hero";
import RoutesSection from "./RoutesSection";
import UpcomingEvents from "../events/UpcomingEvents";
import SponsorBlock from "../sponsors/SponsorBlock";

const HomePage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen"
    >
      <Hero />
      <RoutesSection />
      <UpcomingEvents />
      <SponsorBlock />
    </motion.div>
  );
};

export default HomePage;
